/*****************************************************************************/
/*  File Name: treatmentTable.js                                             */
/*  Date:      July 10, 2023                                                 */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This is the table that will show how much faster you will 
/*             pay it off if you have multiple tips 
/*
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';

//import styles from './styles/roi.module.scss';
import { Grid } from '@mui/material';
import * as TIMERANGE from '../../constants/timeRanges';
import { useROIContext } from '../../context/roiContext';
import styles from './styles/roi.module.scss';
import { convertToCurrency } from '../../functions/convertCurrency';
import { roundNumberUpToWhole } from '../../functions/roundNumberUp';

function TreatmentTable({ t }) {
  //Load all of the default component varaibles

  const { tableBreakdown, selectedTimeRange, roiTipCount } = useROIContext();

  //console.log('this is my selected Breakwodn - ---', selectedTimeBreakdown);

  return (
    <Grid item xs={12} container className={styles.treatmentTable}>
      <Grid item xs={12} className={styles.title}>
        Impact of Multiple Treatments Per {selectedTimeRange === TIMERANGE.weekly ? 'Week' : 'Month'} on Potential Profitability
      </Grid>
      <Grid item xs={12} container className={styles.titleBlock}>
        <Grid item xs={2} className={styles.titleGrid}>
          Treatments/
          <br /> {selectedTimeRange === TIMERANGE.weekly ? 'Week' : 'Month'}
        </Grid>
        <Grid item xs={2} className={styles.titleGrid}>
          {selectedTimeRange} <br />
          Tip Costs
        </Grid>
        <Grid item xs={2} className={styles.titleGrid}>
          {selectedTimeRange} Loan
          <br /> Payment
        </Grid>
        <Grid item xs={2} className={styles.titleGrid}>
          {selectedTimeRange}
          <br />
          Sales
        </Grid>
        <Grid item xs={2} className={styles.titleGrid}>
          {selectedTimeRange}
          <br /> Profit
        </Grid>
        <Grid item xs={2} className={styles.titleGrid}>
          {selectedTimeRange === TIMERANGE.weekly ? 'Weeks' : 'Months'} to
          <br /> Break-Even
        </Grid>
      </Grid>
      <Grid item xs={12} container className={styles.tableDataContainer} >
        {tableBreakdown.length > 0
          ? tableBreakdown.map((row, i) => (
            <Grid item xs={12} container className={`${styles.row} ${roiTipCount === row.treatments ? styles.highlight : ''}`} key={i}>
              <Grid item xs={2} className={styles.data}>
                {row.treatments}
              </Grid>
              <Grid item xs={2} className={styles.data}>
                ${convertToCurrency(row.tipcost)}
              </Grid>
              <Grid item xs={2} className={styles.data}>
                ${convertToCurrency(row.loanPayment)}
              </Grid>
              <Grid item xs={2} className={styles.data}>
                ${convertToCurrency(row.sales)}
              </Grid>
              <Grid item xs={2} className={styles.data}>
                ${convertToCurrency(row.profit)}
              </Grid>
              <Grid item xs={2} className={styles.data}>
                {roundNumberUpToWhole(row.breakEven)}
              </Grid>
            </Grid>
          ))
          : ''}
      </Grid>
    </Grid>
  );
}

export default withTranslation()(TreatmentTable);
